export const buildSuccessMeta = (message: string) => () => ({ message })
